import { Button } from '@bambi/component-library/src/components/Button';
import { TrashIcon } from '@heroicons/react/24/outline';

interface PassengerFormActionsProps {
  isEditing?: boolean;
  // Tracks submitting state/deleting state
  isLoading?: boolean;

  onDelete: () => void;
  onCancel: () => void;
  onSave: () => void;
}
export function PassengerFormActions({
  isEditing,
  isLoading,
  onDelete,
  onCancel,
  onSave,
}: PassengerFormActionsProps) {
  return (
    <div className="flex w-full flex-row justify-between">
      <Button
        onClick={onDelete}
        variant="danger"
        dataTestId="delete-passenger-button"
        disabled={isLoading}
      >
        <TrashIcon className="mr-2 w-5" /> Delete this passenger
      </Button>
      <div className="flex flex-row justify-end gap-2">
        <Button onClick={onCancel} disabled={isLoading} loading={isLoading}>
          Cancel
        </Button>
        <Button
          onClick={onSave}
          disabled={isLoading}
          variant="primary"
          loading={isLoading}
          dataTestId="passenger-form-submit-button"
        >
          {isEditing ? 'Update Passenger' : 'Create Passenger'}
        </Button>
      </div>
    </div>
  );
}
